import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";

import { SharedDataService } from "@app/services/net-remit/shared-data.service";
import { TranslateService } from "@ngx-translate/core";
import { MessageService } from 'primeng/api';

import { fadeRight, fadeLeft } from 'assets/animations/animations';
import { routesConstants } from "@app/shared/models/LinksView";

@Component({
	selector: 'app-login-layout',
	templateUrl: './login-layout.component.html',
	styleUrls: ['./login-layout.component.scss'],
  animations: [fadeRight, fadeLeft],
  standalone: false
})
export class LoginLayoutComponent implements OnInit {

  isFadeLeft: boolean;
  isFadeRight: boolean;
	isLoading : boolean;
  isPasswordUpdated: boolean;
  language: string;
  returnUrl: string;
  showMFAInfo: boolean;

  constructor(
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private sharedDataService: SharedDataService,
    private messageService: MessageService
  ) {
  }

  ngOnInit() {
    this.setLanguage(this.currentLanguage);
    this.route.queryParams.subscribe(params => { this.isPasswordUpdated = !!params['passwordUpdated'] });
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/' + routesConstants.charts;
    setTimeout(() => {
      if(this.isPasswordUpdated){
        this.messageService.add({
          key:'toast-login',
          sticky: true,
          severity:'success',
          summary: this.translateService.instant('Modal.Success'),
          detail: this.translateService.instant('Login.Password Updated Correctly')
        });
      }
    },1000)
  }

  public setLanguage(language: string) {
    localStorage.setItem("language", language);
    this.sharedDataService.updateLanguage();
    this.translateService.use(language);
    this.language = this.currentLanguage;
  }

  get currentLanguage(): string {
    return this.translateService.currentLang;
  }

  get languages(): string[] {
    return this.translateService.langs;
  }

  public toggleShowMFAInformation(value: boolean){
    if(value === false){
      this.isFadeLeft = true;
      this.isFadeRight = false;
    } else {
      this.isFadeRight = true;
      this.isFadeLeft = false;
    }
    this.showMFAInfo = value;
  }
}
